export default {
    token: localStorage.getItem("user-token") || "",
    status: "",
    user: localStorage.getItem("user-name") || "",
    claims: localStorage.getItem("user-claims") || "",
    roles: localStorage.getItem("user-roles") || "",
    isAdmin: localStorage.getItem("user-isAdmin") || false,
    utaPhone: localStorage.getItem("user-uta-phone") || "",
    branch: localStorage.getItem("branch") || "",
    plivoPhone: localStorage.getItem("user-plivo-phone") || "",
};
